export default{
    'logout': 'Вы вышли из системы',
    'login': 'Для начала войдите в систему',
    'auth/user-not-found': 'Пользователся с таким email не существует',
    'auth/wrong-password': 'Не верный пароль',
    'auth/email-already-in-use': 'Пользователь с таким email уже существует'

}